"use strict";

exports.__esModule = true;
exports.getPoolToken = getPoolToken;
function getPoolToken(poolId) {
  if (poolId.isDex) return poolId.asDex;
  if (poolId.isLoans) return poolId.asLoans;

  // always success, never run belown
  return undefined;
}